import { useMemo, useState } from 'react';
import { AllMessagesResponse, Message } from 'src/api/messagesApi';
import { MaterialCircularProgress } from 'src/components/material/CircularProgress';
import { ViewResponseModal } from 'src/pages/Profile/Tabs/Modals/ViewResponseModal/ViewResponseModal';
import { MessageCard } from './MessageCard';
import { normalizeCircleMessages } from './normalizeCircleMessages';
import styles from './CircleMessages.module.scss';

interface CircleMessagesProps {
  videoMessages: AllMessagesResponse;
  isLeader: boolean;
  loading?: boolean;
}

export const CircleMessages = ({
  videoMessages,
  isLeader,
  loading = false,
}: CircleMessagesProps) => {
  const [selectedMessage, setSelectedMessage] = useState<Message | null>(null);

  const messages = useMemo(
    () => normalizeCircleMessages(videoMessages, isLeader),
    [videoMessages, isLeader]
  );

  if (loading && messages.length === 0) {
    return (
      <div className={styles.loader}>
        <MaterialCircularProgress />
      </div>
    );
  }

  if (messages.length === 0) {
    return <div className={styles.emptyState}>No messages in this circle</div>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {messages.map((message) => (
          <MessageCard
            key={message._id}
            message={message}
            onOpen={() => setSelectedMessage(message)}
          />
        ))}
      </div>
      <ViewResponseModal
        isOpenModal={Boolean(selectedMessage)}
        setIsOpenModal={(open) => {
          if (!open) {
            setSelectedMessage(null);
          }
        }}
        responseVideo={selectedMessage}
      />
    </div>
  );
};
